/* eslint-disable camelcase */
import { MainLayout } from '@components/layouts/Index';
import Header from '@components/Header';
import Footer from '@components/Footer';
import { Page } from '@pages/Type';
// TODO: Check is correct using...
import withLayout from '@utils/withLayout';
import withCheckAuth from '@root/utils/withCheckAuth';
import { axiosWithStore, ServerResponse } from '@utils/axios';
import TopSection from './TopSection';
import FaqSection from './FaqSection';
import ContactSection from './ContactSection';
import TosSection from './TosSection';
import getRouteDataFromCtx from '@root/utils/getRouteDataFromCtx';
import { useCallback, useEffect } from 'react';
import { Element, scroller } from 'react-scroll';
import { useRouter } from 'next/router';
import useRouteHref from '@root/utils/useRouteHref';
import withTitle from '@root/utils/withTitle';

export type FaqData = {
    id: number;
    isPublic: number;
    title_translate?: string;
    content_translate?: string;
};

type FaqPageProps = {
    data: FaqData[];
    isLiveHelp: boolean;
};

const Index: Page<FaqPageProps> = ({ data, isLiveHelp }) => {
    const router = useRouter();

    const urlLiveHelp = useRouteHref('landing_live_help');

    const scrollToElement = useCallback(() => {
        scroller.scrollTo('live-help-section', {
            duration: 1500,
            delay: 100,
            smooth: true,
        });
    }, []);

    useEffect(() => {
        if (isLiveHelp) {
            scrollToElement();
        }
        const handleRouteChange = (url) => {
            if (urlLiveHelp === url) {
                scrollToElement();
            }
        };

        router.events.on('routeChangeComplete', handleRouteChange);

        // If the component is unmounted, unsubscribe
        // from the event with the `off` method:
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, []);

    return (
        <>
            <Header />
            <TopSection />
            <FaqSection data={data} />
            <Element name="live-help-section">
                <ContactSection />
            </Element>
            <TosSection />
            <Footer renderTopButton />
        </>
    );
};

export const getServerSideProps = withCheckAuth(async (ctx) => {
    const routeData = getRouteDataFromCtx(ctx);
    const axios = axiosWithStore(ctx.store);
    const data = await axios
        .get<ServerResponse<FaqData[]>>('/public/faq')
        .then((response) => response.data.data)
        .catch(() => []);
    return {
        props: { data, isLiveHelp: routeData?.isLiveHelp || false },
    };
});

export default withTitle(
    {
        translateKey: 'pageTitle',
        keywordsKey: 'pageKeywords',
        descriptionKey: 'pageDescription',
        default: 'Home page',
        namespace: 'landingHelpFaq',
        route: 'landing_services_faq',
    },
    withLayout(MainLayout, Index),
);
